export default "__VITE_ASSET__590d76e1__"